module.exports = __webpack_public_path__ + "img/ALPIQ.2ad3b8ef.png";